import { render, staticRenderFns } from "./TestTwo.vue?vue&type=template&id=3d5394a1&scoped=true"
import script from "./TestTwo.vue?vue&type=script&lang=js"
export * from "./TestTwo.vue?vue&type=script&lang=js"
import style0 from "./TestTwo.vue?vue&type=style&index=0&id=3d5394a1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5394a1",
  null
  
)

export default component.exports